<template>
  <div>
    <validation-provider
      #default="{ errors }"
      name="unity"
      :rules="requiredField ? 'required' : ''"
    >
      <b-form-group
        label="Unidade"
        label-for="unity"
      >
        <v-select
          id="unity"
          v-model="unitySelect"
          :class="errors.length > 0 ? 'error-select' : ''"
          :filter="fuseSearch"
          label="symbol"
          :options="dataOptions"
          :placeholder="readonly ? '' : 'Unidade'"
          :disabled="readonly"
          :clearable="!readonly"
          @open="onCreate()"
        >
          <template #option="{ unity, symbol }">
            <span>{{ unity }} - {{ symbol }}</span>
          </template>

          <template #selected-option="{ symbol }">
            <span>{{ symbol }} </span>
          </template>

          <template #no-options>
            Não há opções de unidades.
          </template>
        </v-select>
        <small class="text-danger">{{ errors[0] }}</small>
      </b-form-group>
    </validation-provider>
  </div>
</template>
<script>
import {
  BFormGroup,
} from 'bootstrap-vue'

import {
  ValidationProvider,
} from 'vee-validate'

import {
  required,
} from '@validations'

import vSelect from 'vue-select'
import Fuse from 'fuse.js'
import syslic from '@/syslic'

export default {
  components: {
    BFormGroup,
    ValidationProvider,
    vSelect,
  },
  model: {
    prop: 'unityValue',
    event: 'unityChange',
  },
  props: {
    unityValue: {
      type: [Object, String],
      required: false,
      default: null,
    },
    readonly: {
      type: Boolean,
      required: true,
    },
    requiredField: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    const dataOptions = []

    return {
      dataOptions,
      required,
    }
  },
  computed: {
    unitySelect: {
      get() {
        return this.unityValue
      },
      set(value) {
        this.$emit('unityChange', value)
      },
    },
  },
  created() {
    this.onCreate()
  },
  methods: {
    onCreate() {
      syslic
        .product
        .unit
        .fetchUnits()
        .then(response => {
          this.dataOptions = response.results
          this.$emit('ready', true)
        })
        .catch(() => {
          this.$emit('ready', true)
        })
    },
    fuseSearch(options, search) {
      const fuse = new Fuse(options, {
        keys: ['unity', 'symbol'],
        shouldSort: true,
      })
      return search.length
        ? fuse.search(search).map(({ item }) => item)
        : fuse.list
    },
  },
}
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
